<template>
  <figure class="featureProgressbar" :class="`status-${props.statusVariante}`">
    <figcaption class="text-bold">
      <span>Erstattungsbetrag</span>
      <span v-if="props.showPrices && props.gesamtpreisGewaehlteProdukte !== null">
        {{ toCurrency(props.gesamtpreisGewaehlteProdukte) }}
      </span>
    </figcaption>
    <div
      :class="`progressbar text-${props.statusVariante}`"
      :style="{ '--width': `${props.aktuelleMenge}%` }"
      :title="`${props.aktuelleMenge}% des maximalen Erstattungsbetrages wurden genutzt`"
    ></div>
    <p class="text-s">
      <PflegeIcon v-if="props.statusVariante === 'success'" name="success-fill" color="success" />
      {{ props.statusText || ' ' }}
    </p>
  </figure>
</template>

<script setup>
import { toCurrency } from '../../utils/formatter'

const props = defineProps({
  aktuelleMenge: {
    type: Number,
    required: false,
    default: 0
  },
  maximalMenge: {
    type: Number,
    required: false,
    default: 100
  },
  statusVariante: {
    type: String,
    required: false,
    default: 'warning',
    validator: (value) => ['danger', 'warning', 'success', ''].includes(value)
  },
  statusText: {
    type: String,
    required: false,
    default: ''
  },
  showPrices: {
    type: Boolean,
    required: false,
    default: true
  },
  gesamtpreisGewaehlteProdukte: {
    type: Number,
    required: false,
    default: null
  }
})
</script>

<style scoped>
.curapick .featureProgressbar {
  margin: 0;
  padding: 0.5rem 1rem;

  @container (width < 430px) {
    & {
      padding-top: 0.33rem;
    }
  }
}

.curapick .featureProgressbar .text-s {
  font-size: 0.9em;
}

/* styling progressbar */
.curapick .featureProgressbar .progressbar {
  --radius: 0.33rem;
  height: 0.67em;
  width: 100%;
  border-radius: var(--radius);
  background-color: var(--neutral-5);
  position: relative;
}
.curapick .featureProgressbar .progressbar::after {
  content: '';
  display: inline-block;
  position: absolute;
  background-color: currentColor;
  width: var(--width, 0);
  max-width: 100%;
  height: 100%;
  border-radius: var(--radius);
  transition:
    color 1s ease-in-out,
    width var(--time2) ease-in-out;
}
.curapick .featureProgressbar .progressbar[title^='0%']::after {
  aspect-ratio: 1;
  width: auto;
}

/* styling texts */
.curapick .featureProgressbar figcaption {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.curapick .featureProgressbar p {
  padding-block-start: 0.25rem;
  margin: 0;
}
.curapick .featureProgressbar p svg {
  float: inline-end;
}
</style>
